import { Avatar } from '@/components/Avatar'
import { FormGroup } from '@/components/Form'
import {
  CustomSelect,
  MultiItemSelectedDefault,
} from '@/components/inputs/CustomSelect'
import { useCustomSelectStateFromInfiniteScrollProvider } from '@/components/inputs/infinite-scroll-provider-hook'
import { SearchResultItem } from '@/components/inputs/SearchResultItem'
import { observer } from 'mobx-react-lite'
import { type SupportingClientSelectorViewModel } from '@/features/jobs/drafting/SupportingClientSelectorViewModel'

export interface CompactSupportingClientSelectorContainerProps {
  vm: SupportingClientSelectorViewModel
}

export const CompactSupportingClientSelectorContainer = observer(
  function CompactSupportingClientSelectorContainer({
    vm,
  }: CompactSupportingClientSelectorContainerProps) {
    const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
      scrollProvider: vm.scroller,
      searchText: vm.searchText.value,
      onSearchTextChange: vm.triggerSearch,
    })

    return (
      <FormGroup>
        <CustomSelect
          {...selectProps}
          placeholder="Select supporting clients."
          itemToString={(v) => String(v?.displayName)}
          isDisabled={vm.disabled}
          focus$={vm.step.becomeActive$}
          onFocus={vm.step.onBecameActive}
          value={vm.selectedSupportingClient}
          onChange={vm.selectClientSupport}
          multi={true}
          testId="compact-supporting-client-selector"
          renderItem={(itemProps) => (
            <MultiItemSelectedDefault
              visual={
                <Avatar
                  size={24}
                  subject={{
                    displayName: itemProps.item.displayName,
                    avatar: itemProps.item.avatar,
                  }}
                />
              }
              {...itemProps}
            />
          )}
          renderSearchItem={({
            item,
            itemToString: _itemToString,
            ...itemProps
          }) => (
            <SearchResultItem
              {...itemProps}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    avatar: item.avatar,
                    displayName: item.displayName,
                  }}
                />
              }
            >
              {item.displayName}
            </SearchResultItem>
          )}
        />
      </FormGroup>
    )
  },
)
